import React, { useState, useEffect, useContext } from "react";
import { DivisionContract, TreeNodeModel } from "../tree/types";
import Message from "../ui/Message";
import { AuthContext } from "../../context/auth";

interface Props {
  node: TreeNodeModel;
  onSave: (node: TreeNodeModel, division: any) => void;
  onChange: (node: TreeNodeModel) => void;
  readOnly?: boolean;
}

interface DivisionFormData {
  product: string;
  contractName: string;
  egwPaymentFacilitator: string;
  payfacMastercardId?: string;
  payfacVisaId?: string;
}

export const DivisionForm: React.FC<Props> = ({
  node,
  onSave,
  readOnly,
  onChange
}) => {

  const { user } = useContext(AuthContext);

  const [form, setForm] = useState<DivisionFormData>({
    product: "052-Acq Division level",
    contractName: node?.name ?? "",
    egwPaymentFacilitator: "N",
    payfacMastercardId: "",
    payfacVisaId: ""
  });

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {

    if (node?.entityData) {

      setForm(node.entityData as DivisionContract);

    } else {

      setForm({
        product: "052-Acq Division level",
        contractName: node?.name ?? "",
        egwPaymentFacilitator: "N",
        payfacMastercardId: "",
        payfacVisaId: ""
      });

    }

    setErrorMessage("");

  }, [node.id]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {

    const { name, value } = e.target;

    let updatedForm = {
      ...form,
      [name]: value
    };

    // Si deja de ser Payfac limpiamos los IDs
    if (name === "egwPaymentFacilitator" && value === "N") {
      updatedForm.payfacMastercardId = "";
      updatedForm.payfacVisaId = "";
    }

    setForm(updatedForm);

    const updatedNode: TreeNodeModel = {
      ...node,
      name: updatedForm.contractName,
      saved: true,
      entityData: updatedForm
    } as any;

    onChange(updatedNode);

  };

  const handleSave = () => {

    if (!form.contractName?.trim()) {
      setErrorMessage("Por favor complete todos los campos requeridos.");
      return;
    }

    if (form.egwPaymentFacilitator === "Y") {

      if (!form.payfacMastercardId || !form.payfacVisaId) {
        setErrorMessage("Debe ingresar los IDs de Payfac Visa y Mastercard.");
        return;
      }

    }

    const updatedNode: TreeNodeModel = {
      ...node,
      name: form.contractName,
      saved: true,
      entityData: form
    } as any;

    // onChange(updatedNode);

    onSave(
      updatedNode,
      form
    );

  };

  const removeError = () => setErrorMessage("");

  return (
    <div className="container-fluid">

      <h5 className="mb-3">División</h5>

      <div className=" col-md-6 mb-3">
        <label className="form-label">Producto</label>
        <input
          className="form-control"
          value="Nivel División"
          disabled
        />
      </div>

      <div className="col-md-6 mb-3">
        <label className="form-label">Nombre de la División *</label>
        <input
          name="contractName"
          className="form-control"
          value={form.contractName}
          onChange={handleChange}
          placeholder="Nombre de la división"
          disabled={readOnly}
        />
      </div>

      {
        user?.isLafise && (
          <div className="col-md-6 mb-3">

            <label className="form-label">
              Payfac
            </label>

            <select
              name="egwPaymentFacilitator"
              className="form-select"
              value={form.egwPaymentFacilitator}
              onChange={handleChange}
              disabled={readOnly || node.isExistent}
            >
              <option value="N">No</option>
              <option value="Y">Si</option>
            </select>

          </div>
        )
      }

      {form.egwPaymentFacilitator === "Y" && (
        <>
          <div className="col-md-6 mb-3">

            <label className="form-label">
              Payfac MasterCard Id *
            </label>

            <input
              name="payfacMastercardId"
              className="form-control"
              value={form.payfacMastercardId || ""}
              onChange={handleChange}
              disabled={readOnly}
            />

          </div>

          <div className="col-md-6 mb-3">

            <label className="form-label">
              Payfac Visa Id *
            </label>

            <input
              name="payfacVisaId"
              className="form-control"
              value={form.payfacVisaId || ""}
              onChange={handleChange}
              disabled={readOnly}
            />

          </div>
        </>
      )}

      {!readOnly && (
        <button
          className="btn btn-primary"
          onClick={handleSave}
        >
          Guardar División
        </button>
      )}

      {errorMessage.length > 0 && (
        <Message
          type="error"
          message={errorMessage}
          closeDialog={removeError}
          handleOk={removeError}
          backgroundColor="rgba(0,0,0,0.4)"
        />
      )}

    </div>
  );
};